import { TERMS_TEXT, TERMS_VERSION, LOGO_URL } from "@/api";

export default function TermsPage() {
  return (
    <main data-testid="terms-page" className="min-h-[calc(100vh-74px)] bg-[#F7F2EA] px-4 py-10 md:px-8 md:py-16">
      <section className="mx-auto max-w-4xl">
        <img data-testid="terms-logo-image" src={LOGO_URL} alt="Bonsai Broker" className="mx-auto mb-8 h-28 w-28 rounded-full object-cover object-center shadow-lg shadow-black/10" />
        <p data-testid="terms-version" className="text-xs uppercase tracking-[0.22em] text-[#b84f3c]">Effective {TERMS_VERSION}</p>
        <h1 data-testid="terms-heading" className="mt-3 text-5xl font-light text-[#1A3626] md:text-6xl">Terms of Service</h1>
        <pre data-testid="terms-full-text" className="mt-8 whitespace-pre-wrap border border-[#D5D1C4] bg-[#fffdf7] p-6 text-sm leading-7 text-[#26352b]">{TERMS_TEXT}</pre>
      </section>
    </main>
  );
}